import React, { memo, useCallback } from 'react';
import Grid from '@mui/material/Grid';
import Typography from '@mui/material/Typography';
import PropTypes from 'prop-types';
import { useHistory } from 'react-router-dom';

import { usePermission } from '../../permissions';

import columnLinksStyles from './columnLinksStyles';

const ColumnLinks = (props) => {
    const { items, className, basePath } = props;
    const classes = columnLinksStyles();
    const history = useHistory();

    const handleClick = useCallback(
        (link) => () => {
            history.push(link.startsWith('/') ? link : `${basePath ? `/${basePath}` : ''}/${link}`);
        },
        [basePath, history]
    );

    return (
        <Grid className={className}>
            {items.filter((item) => !item.notDeveloped).map((item, idx) => {
                const { title, body, icon: Icon, link, notDeveloped, permissionId } = item;
                const noPermission = permissionId ? !usePermission(permissionId) : false;
                return (
                    <Grid
                        className={classes.wrapContent}
                        key={idx}
                        container
                        wrap="nowrap"
                        alignItems="center"
                    >
                        <Icon
                            className={`${classes.icon} 
                            ${notDeveloped || noPermission ? classes.iconNotDeveloped : ''}
                            `}
                            onClick={handleClick(link)}
                        />
                        <Grid container direction="column">
                            <Typography
                                className={`${classes.categoryTitle} 
                                ${notDeveloped ? classes.titleNotDeveloped : ''}
                                ${noPermission ? classes.noPermission : ''}
                                `}
                                variant="subtitle2"
                                onClick={handleClick(link)}
                            >
                                {title}
                            </Typography>
                            <Typography className={classes.categoryBody} variant="body2">
                                {body}
                            </Typography>
                        </Grid>
                    </Grid>
                );
            })}
        </Grid>
    );
};
ColumnLinks.defaultProps = {
    className: '',
    items: {
        title: '',
        body: '',
        icon: <span />,
        link: '',
        notDeveloped: false,
        permissionId: ''
    },
    basePath: ''
};
ColumnLinks.propTypes = {
    items: PropTypes.arrayOf(
        PropTypes.shape({
            title: PropTypes.string,
            body: PropTypes.string,
            icon: PropTypes.elementType,
            link: PropTypes.string
        })
    ).isRequired,
    className: PropTypes.string,
    basePath: PropTypes.string
};

export default memo(ColumnLinks);
